import type { TrainTranslations } from "./trainTranslations.types";

const trainFrTranslations: TrainTranslations = {
    trainPage: {
        title: "Train",
        step: "Étape",
        resultsFound: "options de train trouvées",
        stopOver: "Correspondance",
        stopOverPlural: "Correspondances",
        nextStep: "Étape suivante",
        loadingTimeline: "Chargement des horaires…",
    },
    trainSortBy: {
        title: "Trier par",
        price_asc: "Prix le plus bas d'abord",
        price_desc: "Prix le plus élevé d'abord",
        fastest: "Le plus rapide",
        fewest_changes: "Le moins de correspondances"
    },
    trainBlock: {
        title: "Service de train",
        direct: "Direct",

    },
    trainFilters: {
        outboundTrip: {
            title: "Horaires trains aller",
            duration: "Durée",
            departure: {
                location: "",
                time: "Départ"
            },
            arrival: {
                location: "Gare d'arrivée",
                time: "Arrivée"
            }
        },
        inboundTrip: {
            title: "Horaires trains retour",
            duration: "Durée",
            departure: {
                location: "",
                time: "Départ"
            },
            arrival: {
                location: "",
                time: "Arrivée"
            }
        },
        operators: "Opérateur",
        duration: "Durée du trajet"
    },
    stationsNames: {
        STP: "London St Pancras",
        EBB: "Ebbsfleet International",
        AFI: "Ashford International",
        CMF: "Chambéry-Savoie",
        XAP: "Aime-la-Plagne",
        XBM: "Bourg-Saint-Maurice",
        XBMA: "Bourg St Maurice",
        XAV: "Albertville",
        XMO: "Moûtiers",
        XDB: "Lille Europe",
        PLY: "Paris - Gare de Lyon",
        PEST: "Paris - Gare de l'Est",
        AMS: "Amsterdam Centraal",
        RTM: "Rotterdam Centraal",
        ANR: "Anvers",
        BRU: "Bruxelles Midi",
        "Bourg-Saint-Maurice": "Gare de Bourg-Saint-Maurice",
        "Aime-la-Plagne": "Gare de Aime-la-Plagne",
        "Moûtiers": "Gare de Moûtiers",
    },
    operatorsNames: {
        ES: "Eurostar",
        "9F": "Eurostar",
        SNCF: "SNCF",
        PEG: "Pegasus Train"
    },
    trainClass: {
        standard: "Eco",
        premium: "Premier",
        title: "Classes de train",
        outOfStock: "Indisponible"
    }
};

export default trainFrTranslations;
